import { useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { Suspense } from "react";
import { Heading } from "@/components/catalyst/Heading";
import {
	Tabs,
	TabsIndicator,
	TabsList,
	TabsPanel,
	TabsTab,
} from "@/components/Tabs";
import { EditTab } from "./EditTab";
import { OfferCodesTab } from "./OfferCodesTab";
import { OfferCodesTabSkeleton } from "./OfferCodesTabSkeleton";
import { ReferralLinkDetailSkeleton } from "./ReferralLinkDetailSkeleton";

export function ReferralLinkDetailPage() {
	const { appId, linkId } = useParams({
		from: "/_app/apps/$appId/links/$linkId/",
	});

	const { tab } = useSearch({ from: "/_app/apps/$appId/links/$linkId/" });
	const navigate = useNavigate();

	const handleTabChange = (value: string | number | null) => {
		if (typeof value === "string") {
			navigate({
				to: "/apps/$appId/links/$linkId",
				params: { appId, linkId },
				search: (prev) => ({ ...prev, tab: value as "edit" | "offer_codes" }),
			});
		}
	};

	return (
		<>
			<div className="flex items-center justify-between mb-8">
				<Heading>Edit Referral Link</Heading>
			</div>

			<Tabs value={tab} onValueChange={handleTabChange} className="w-full">
				<TabsList>
					<TabsTab value="edit">Edit</TabsTab>
					<TabsTab value="offer_codes">Offer Codes</TabsTab>
					<TabsIndicator />
				</TabsList>
				<TabsPanel value="edit">
					<div className="py-4">
						<Suspense fallback={<ReferralLinkDetailSkeleton />}>
							<EditTab />
						</Suspense>
					</div>
				</TabsPanel>
				<TabsPanel value="offer_codes">
					<div className="py-4">
						<Suspense fallback={<OfferCodesTabSkeleton />}>
							<OfferCodesTab />
						</Suspense>
					</div>
				</TabsPanel>
			</Tabs>
		</>
	);
}
